import React, { useState, useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { cachedGet } from '../utils/apiCache';

const OpenQuestionsByTopic = () => {
  const { oppositionName } = useParams();
  const navigate = useNavigate();
  const [topics, setTopics] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    // Misma clave de caché que ExamByTopic.js: si el usuario ya visitó una de
    // las dos pantallas, la otra no vuelve a pedir la lista.
    cachedGet(`topics:${oppositionName}`, () => axios.get(`/api/topics/${oppositionName}`))
      .then((res) => { if (!cancelled) setTopics(res.data); })
      .catch((e) => console.error('Error fetching topics', e))
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [oppositionName]);

  if (loading) return <div className="page-loader">Cargando temas…</div>;

  return (
    <div>
      <button onClick={() => navigate(`/oposicion/${oppositionName}`)} className="back-link">← Volver</button>
      <header className="page-header">
        <h1 className="page-title">Preguntas abiertas</h1>
        <p className="page-subtitle">{oppositionName} · elige un tema para practicar con respuesta libre</p>
      </header>
      {topics.length === 0 ? (
        <div className="empty-state"><p>No hay temas disponibles.</p></div>
      ) : (
        <div className="list-grid">
          {topics.map((t, i) => (
            <Link
              key={i}
              to={`/oposicion/${oppositionName}/preguntas-abiertas/${encodeURIComponent(t)}`}
              className="list-item"
            >
              <span className="list-item-title">{t}</span>
              <span className="list-item-arrow">→</span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default OpenQuestionsByTopic;
